import { Box, VStack } from "@chakra-ui/react";
import { Field, FormInput, FormTextarea, FormSwitch } from "@/components/jobOffer/ui/inputs";
import { SectionCard, SectionHeader, Divider, Grid2 } from "@/components/jobOffer/ui/layout";
import { AddButton, ItemHeader, RepeatableText } from "@/components/jobOffer/ui/listHelpers";

const newObjection = () => ({ objection: "", responseStyle: "", argument: "", alternativeOffer: "", allowDiscount: false, followUpQuestion: "" });

const StepSalesEnablement = ({ values, onChange }) => {
    const salesArguments = (values.salesArguments ?? []).map(a => a.argument ?? a);
    const setSalesArguments = (strings) => onChange({ ...values, salesArguments: strings.map(s => ({ argument: s, category: null })) });

    const objections = values.objections ?? [];
    const setObjections = (next) => onChange({ ...values, objections: next });
    const updateObjection = (i, patch) => setObjections(objections.map((o, idx) => idx === i ? { ...o, ...patch } : o));
    const removeObjection = (i) => setObjections(objections.filter((_, idx) => idx !== i));
    const addObjection = () => setObjections([...objections, newObjection()]);

    return (
        <VStack w="full" align="stretch" gap={4}>
            <SectionCard>
                <SectionHeader number={4} title="Argumenty sprzedażowe" subtitle="Najważniejsze przewagi używane w rozmowie" />
                <RepeatableText values={salesArguments} onChange={setSalesArguments} placeholder="np. Szybkość wdrożenia" label="Argumenty" />
            </SectionCard>

            <SectionCard>
                <SectionHeader number={5} title="Obiekcje" subtitle="Jak Agent ma reagować na typowe zastrzeżenia klienta" />
                <VStack align="stretch" gap={4}>
                    {objections.map((o, i) => (
                        <Box key={i} borderWidth={1} borderColor="border.primary" borderRadius={8} p={4}>
                            <ItemHeader title={o.objection || "Nowa obiekcja"} index={i} onRemove={() => removeObjection(i)} />
                            <VStack align="stretch" gap={3}>
                                <Field label="Obiekcja" required hint='np. "To za drogo"'>
                                    <FormInput value={o.objection} onChange={(e) => updateObjection(i, { objection: e.target.value })} />
                                </Field>
                                <Grid2>
                                    <Field label="Sposób odpowiedzi">
                                        <FormInput value={o.responseStyle ?? ""} onChange={(e) => updateObjection(i, { responseStyle: e.target.value })} />
                                    </Field>
                                    <Field label="Alternatywna oferta">
                                        <FormInput value={o.alternativeOffer ?? ""} onChange={(e) => updateObjection(i, { alternativeOffer: e.target.value })} />
                                    </Field>
                                </Grid2>
                                <Field label="Argument"><FormTextarea value={o.argument ?? ""} onChange={(e) => updateObjection(i, { argument: e.target.value })} rows={2} /></Field>
                                <Field label="Pytanie pogłębiające"><FormInput value={o.followUpQuestion ?? ""} onChange={(e) => updateObjection(i, { followUpQuestion: e.target.value })} /></Field>
                                <FormSwitch label="Możliwość rabatu" checked={!!o.allowDiscount} onChange={(v) => updateObjection(i, { allowDiscount: v })} />
                            </VStack>
                        </Box>
                    ))}
                    <AddButton label="Dodaj obiekcję" onClick={addObjection} />
                </VStack>
            </SectionCard>
        </VStack>
    );
};

export default StepSalesEnablement;
